import { axios } from '@/axios'

export const getOrder = () => {
    return axios
        .get(`/orders`)
        .then(res => {
            if (res.data) {
                return res.data
            }
            return {}
        })
}


export const doPayment = (params) => {
    return axios
        .post(`/orders/payment`, params)
        .then(res => {
            if (res.data) {
                return res.data
            }
            return {}
        })
}
